import { LightBox } from 'experience-kit';

class PhotoGrid {
    constructor (){
		this.photogrid_item_template = '<div class="photogrid__item">';
		this.photogrid_item_template += 	'<a data-lightbox-trigger="#revealLightbox" href="#" title="" role="button" data-index="##INDEX##">';
		this.photogrid_item_template += 	'<img src="##IMGSRCTHUMB##" alt=""/></a></div>';
		this.phtotogrid_template = '<div class="photogrid photogrid--##NUM_PHOTOS##">##TEMPLATE_ITEM##</div>';

		this.carousel_item_template = '<li class="glide__slide"><img src="##IMGSRC##" alt=""/></li>';
		this.carousel_bullet_template = '<i class="ui-pin-pad" data-glide-dir="=##BULLET_INDEX##"></i>';
    }

    setupGallery( gallery ){
		if( "undefined" == typeof gallery) return false;

		var photo_section = document.querySelector("div.photo-gallery");

		if( null != photo_section ){
			var num_photos = gallery.length;
			var all_photos = "";
			var all_carousel_items = "";
			var all_bullet_items = "";
			for( var j=0; j < gallery.length; j++ ){
				//Load all images in gallery
				all_photos += this.photogrid_item_template.replace(/##IMGSRCTHUMB##/g, gallery[j].thumbnail)
					.replace(/##INDEX##/,j);

				//Load all images in carousel
				all_carousel_items += this.carousel_item_template.replace(/##IMGSRC##/g, gallery[j].original);

				//Load bullets per image
				all_bullet_items += this.carousel_bullet_template.replace("##BULLET_INDEX##", j);
			}

			photo_section.innerHTML = this.phtotogrid_template
				.replace("##NUM_PHOTOS##", num_photos)
				.replace("##TEMPLATE_ITEM##", all_photos);
			if( num_photos ) {
				//document.querySelector(".carousel .carousel--basic ul").innerHTML = all_carousel_items;
				document.querySelector(".light-box ul").innerHTML = all_carousel_items;
				document.querySelector(".light-box div.glide__bullets").innerHTML = all_bullet_items;

				//document.addEventListener("DOMContentLoaded", () => {
					//reload LightBox
					//window.ExperienceTheme.lightBox = LightBox.init({ initSelector: '.design-lightbox', dataHelpers: { afterHideLightBox: function (){} } });
					window.ExperienceTheme.lightBox = new LightBox({ initSelector: '.design-lightbox', dataHelpers: { afterHideLightBox: function (){} } });
					//mount Glidejs
					window.ExperienceTheme.glide.mount();
				//});
				/*//reload LightBox
				if( "undefined" != typeof window.ExperienceTheme ) {
					window.ExperienceTheme.lightBox = new LightBox({ initSelector: '.design-lightbox' });
					//mount Glidejs
					window.ExperienceTheme.glide.mount();
				} else {
					new LightBox({ initSelector: '.design-lightbox', dataHelpers: { afterHideLightBox: '' } });
					new Glide('.glide').mount();
				}*/

				//Add event listener to each photo so when you click on it the lightbox will show the clicked photo
				var img_links = document.querySelectorAll(".photogrid__item a");
				for( var i = 0; i < img_links.length; i++ ){
					img_links[i].addEventListener('click', function(event){
						var index = event.target.getAttribute("data-index");
						window.ExperienceTheme.glide.update({startAt: index});
					});
				}
			}
		}
    }
}
export default PhotoGrid